export const mapOptionsOrder = (array: string[], order: string[]) => {
  array.sort((a: any, b: any) => {
    return order.indexOf(a) < order.indexOf(b) ? -1 : 1;
  });
  return array;
};
